import './App.css';
import { BrowserRouter as Router, Switch, Route, } from "react-router-dom";
import Header from './Pages/Shared/Header/Header';
import HowWorks from './Pages/HowWorks/HowWorks';
import AboutUs from './Pages/AboutUs/AboutUs';
import HelpCenter from './Pages/HelpCenter/HelpCenter';
import Finance from './Pages/Finance/Finance';
import Footer from './Pages/Shared/Footer/Footer';
import Home from './Pages/Home/Home/Home';

function App() {
  return (
    <div className="App">

      <Router>
        <Header />
        <Switch>
          <Route exact path="/">
            <Home></Home>
          </Route>

          <Route path="/home">
            <Home></Home>
          </Route>

          <Route path="/how-it-works">
            <HowWorks></HowWorks>
          </Route>

          <Route path="/about-us">
            <AboutUs></AboutUs>
          </Route>
          <Route path="/help-center">
            <HelpCenter></HelpCenter>
          </Route>
          <Route path="/about-us">
            <Finance></Finance>
          </Route>


        </Switch>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
